module.exports = __webpack_public_path__ + "img/le-soldat-rose.6fcaeb3d.jpg";